import intl from "react-intl-universal";
import {
  TbBuildingBank,
  TbCreditCard,
  TbShield,
  TbWallet,
} from "react-icons/tb";
import { CurrencyIcon } from "../../../../../Components/Atoms/CurrencyIcon";
import { SummaryCard } from "../../../../../Components/Atoms/SummaryCard";
import {
  BAAS_ACCOUNT_TYPES,
  getBaasBalanceTotal,
} from "../../../../../Services/baasAccountsApi";
import { formatMonetaryValue } from "../../../../../Utils/formatters";

const getCurrencyBalance = (balances = [], currency) =>
  balances.find((balance) => String(balance.currency || "").toUpperCase() === currency);

const getAccountCurrencyTotal = (account, currency) => {
  const balance = getCurrencyBalance(account?.balances, currency);
  if (!balance) {
    return 0;
  }
  return getBaasBalanceTotal(balance);
};

const findSubAccountByType = (subAccounts = [], type) =>
  subAccounts.find((account) => account.type === type);

const createCurrencySummaryIcon = (currency) => {
  const CurrencySummaryIcon = ({ className = "" }) => (
    <CurrencyIcon
      asset={String(currency).toLowerCase()}
      size={18}
      className={className}
    />
  );
  return CurrencySummaryIcon;
};

export const BaasProcessingSummaryCards = ({
  hierarchy,
  displayCurrency,
  showCurrencyIcon = false,
  title,
}) => {
  const rootAccount = hierarchy?.rootAccount;
  const subAccounts = hierarchy?.subAccounts ?? [];
  const rootBalances = rootAccount?.balances ?? [];
  const primaryCurrency =
    (displayCurrency && String(displayCurrency).toUpperCase()) ||
    getCurrencyBalance(rootBalances, "BRL")?.currency?.toUpperCase() ||
    String(rootBalances[0]?.currency || "BRL").toUpperCase();

  const rootTotal = getAccountCurrencyTotal(rootAccount, primaryCurrency);
  const operationalTotal = getAccountCurrencyTotal(
    findSubAccountByType(subAccounts, BAAS_ACCOUNT_TYPES.OPERATIONAL),
    primaryCurrency,
  );
  const overdraftTotal = getAccountCurrencyTotal(
    findSubAccountByType(subAccounts, BAAS_ACCOUNT_TYPES.OVERDRAFT),
    primaryCurrency,
  );
  const reserveTotal = getAccountCurrencyTotal(
    findSubAccountByType(subAccounts, BAAS_ACCOUNT_TYPES.RESERVE),
    primaryCurrency,
  );

  const currencyIcon = createCurrencySummaryIcon(primaryCurrency);

  const cards = [
    {
      key: "root",
      icon: TbBuildingBank,
      title: intl.get("baas.processing.accountTypeRoot"),
      value: formatMonetaryValue(rootTotal, primaryCurrency),
    },
    {
      key: "operational",
      icon: TbWallet,
      title: intl.get("baas.processing.accountTypeOperational"),
      value: formatMonetaryValue(operationalTotal, primaryCurrency),
    },
    {
      key: "overdraft",
      icon: TbCreditCard,
      title: intl.get("baas.processing.accountTypeOverdraft"),
      value: formatMonetaryValue(overdraftTotal, primaryCurrency),
    },
    {
      key: "reserve",
      icon: TbShield,
      title: intl.get("baas.processing.accountTypeReserve"),
      value: formatMonetaryValue(reserveTotal, primaryCurrency),
    },
  ];

  return (
    <section className="mb-1 min-w-0 w-full">
      <p className="dashboard-section-label mb-3">
        {title || intl.get("baas.processing.summarySection")}
      </p>
      <div className="dashboard-card-grid">
        {cards.map((card) => (
          <SummaryCard
            key={card.key}
            icon={showCurrencyIcon ? currencyIcon : card.icon}
            title={card.title}
            value={card.value}
          />
        ))}
      </div>
    </section>
  );
};